export const SPLIT_PANEL_DEFAULT_SIZE = 460;
